import React from "react";
import "./Buttons.css";
import { Link } from "react-router-dom";

const Buttons = (props) => {
  const newFilteredResult = [];
  props.filteredSentRespondants.respondents.filter((onlyFilteredStatus) => {
    if (onlyFilteredStatus.assessment_status__status_name == "Completed") {
      return newFilteredResult.push(
        onlyFilteredStatus.assessment_status__status_name
      );
    }
  });
  return (
    <React.Fragment>
      {props.sentRespondants.length == 0 ? null : (
        <div className="buttons custom-invitations-button">
          {props.minRespondants.length &&
          newFilteredResult.length >= props.batchMinRespondants ? (
            <Link
              to={{
                pathname: `/new/app/submitassessment/${props.sentRespondantsId}/${props.idOfParticipant}/submitAssessment/${props.isMultiRater}`,
              }}
            >
              <button className="ready-to-submit-enabled">
                READY TO SUBMIT
              </button>
            </Link>
          ) : (
            <button className="ready-to-submit-disabled">
              READY TO SUBMIT
            </button>
          )}

          {props.sentRespondants.length == 0 ? (
            <button className="ready-to-submit-disabled">
              INVITE RESPONDENTS
            </button>
          ) : (
            <button
              className="invite-respondents"
              onClick={props.handleInvitationsModal}
            >
              INVITE RESPONDENTS
            </button>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Buttons/Buttons.jsx